<template>
  <div>
    <div v-if="!loading">
      <div v-if="sessionvalue">
        <div v-if="!isEdit" style="float: right">
          <v-btn @click="editBtn" icon>
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
        <v-card-text style="color: black">
          <div style="font-weight: bold">Customer</div>
          <div style="font-size: 10px !important">Name</div>
          <div v-if="!isEdit">
            {{
              sessionvalue.beaverman_customer && sessionvalue.beaverman_customer.name
                ? sessionvalue.beaverman_customer.name
                : '-'
            }}
          </div>
          <div v-else class="form-control">
            <input type="text" v-model="input.beaverman_customer.name" />
          </div>
          <div style="font-size: 10px !important">Phone</div>
          <div v-if="!isEdit">
            {{
              sessionvalue.beaverman_customer && sessionvalue.beaverman_customer.phone_number
                ? sessionvalue.beaverman_customer.phone_number
                : '-'
            }}
          </div>
          <div v-else class="form-control">
            <input type="number" v-model="input.beaverman_customer.phone_number" />
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text style="color: black">
          <div style="font-weight: bold">Contractor</div>
          <div style="font-size: 10px !important">Name</div>
          <div v-if="!isEdit">
            {{
              sessionvalue.beaverman_contractor && sessionvalue.beaverman_contractor.name
                ? sessionvalue.beaverman_contractor.name
                : '-'
            }}
          </div>
          <div v-else class="form-control">
            <input type="text" v-model="input.beaverman_contractor.name" />
          </div>
          <div style="font-size: 10px !important">Phone</div>
          <div v-if="!isEdit">
            {{
              sessionvalue.beaverman_contractor && sessionvalue.beaverman_contractor.phone_number
                ? sessionvalue.beaverman_contractor.phone_number
                : '-'
            }}
          </div>
          <div v-else class="form-control">
            <input type="number" v-model="input.beaverman_contractor.phone_number" />
          </div>
        </v-card-text>
        <div v-if="isEdit" class="text-xs-center">
          <v-btn @click="cancelEdit" outline color="grey">{{ $t('cancel') }}</v-btn>
          <v-btn @click="confirmEdit" :loading="saveloading" depressed color="primary">{{
            $t('Confirm')
          }}</v-btn>
        </div>
      </div>
      <div v-else>
        <div class="text-xs-center mt-5" style="color: darkgrey">ไม่มีข้อมูล</div>
      </div>
    </div>
    <div v-else class="text-xs-center mt-3">
      <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value', 'userid', 'pageid'],
  data() {
    return {
      saveloading: false,
      input: {
        beaverman_customer: {
          name: '',
          phone_number: ''
        },
        beaverman_contractor: {
          name: '',
          phone_number: ''
        }
      },
      isEdit: false,
      sessionvalue: {
        beaverman_customer: {
          name: '',
          phone_number: ''
        },
        beaverman_contractor: {
          name: '',
          phone_number: ''
        }
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getUser()
  },
  methods: {
    cancelEdit() {
      this.input = {
        beaverman_customer: {
          name: '',
          phone_number: ''
        },
        beaverman_contractor: {
          name: '',
          phone_number: ''
        }
      }
      this.isEdit = false
    },
    confirmEdit() {
      this.saveloading = true
      var data = {
        userid: this.value.userid,
        pageid: this.pageid,
        json_variable: this.input
      }

      api.putbeavermanuserinfo(data, (err, response) => {
        if (response && response.responsecode == 200) {
          this.sessionvalue = this.input
          this.saveloading = false
          this.cancelEdit()
        }
      })
    },
    editBtn() {
      Object.assign(this.input, this.sessionvalue)

      this.isEdit = true
    },
    getUser() {
      return new Promise((resolve) => {
        this.loading = true
        var data = {
          pageid: this.pageid,
          userid: this.value.userid
        }
        api.getUserOnly(data, (err, response) => {
          if (response.responsecode == 200 && response.data) {
            try {
              if (response.data[0].json_variable) {
                this.sessionvalue = JSON.parse(response.data[0].json_variable)
              }
            } catch (error) {
              // this.sessionvalue = ''
            }
          }
          this.loading = false
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/BeavermanContract.vue